"use strict";

/**
 * Предоставляет инструменты для работы с уведомлениями Агента веб-доступа, обеспечивающие взаимодействие Агента с пользователем.
 *
 * @namespace WebAccess.agent.notifications
 * @since 5.1.0.1500
 */
(function (global) {
  var notifications = {

    /**
     * Отобразать уведомление для пользователя.
     *
     * @method WebAccess.agent.notifications.show
     * @param {string} message Текст сообщения
     * @return {Deferred<Object>} Результат запроса.
     * @see https://api.jquery.com/category/deferred-object/
     */
    show: function (message) {
      var d = $.Deferred();
      global.transmitRequest("Notify", "NotificationPlugin", { message: message }).always(function(res) {
        d.resolve(res);
      });
      return d.promise();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.notifications = notifications;
})(window.WebAccess.agent);
